import { fetchData } from "./fetch";

export const getLocations = (data) => fetchData('GET', '/instagram/locations', data);

export const getInterests = () => fetchData('GET', '/instagram/interests');

export const getLanguages = () => fetchData('GET', '/instagram/languages');

export const getBrands = (data) => fetchData('GET', '/instagram/brands', data);

export const getTopics = (data) => fetchData('GET', '/instagram/topics', data);

export const searchInfluencers = ({ data, network }) => fetchData('POST', `/${network}/search`, data);

export const getLists = (data) => fetchData('GET', '/instagram/lists', data);

export const createList = (data) => fetchData('POST', '/instagram/lists', data);

export const removeList = (id) => fetchData('DELETE', `/instagram/lists/${id}`);

export const addInfluencerToList = (data) => fetchData('POST', '/instagram/lists/add-influencer', data);

export const removeInfluencerFromList = (data) => fetchData('POST', '/instagram/lists/remove-influencer', data);

export const getInfluencerByUserId = (id) => fetchData('GET', `/instagram/influencers/${id}`);

export const getInfluencersByListId = ({ id, data }) => fetchData('GET', `/instagram/lists/${id}/influencers`, data);

export const exportList = ({ id, data }) => fetchData('POST', `/instagram/lists/${id}/export`, data);
